import { QueryClient, useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';
import { queryOptions } from '@domains/pdp-common';

import { getPdpSizeInputPage } from '../graphql/pdp-size-input-page.2';
import { GetPdpSizeInputPageVariables } from '../graphql/pdp-size-input-page_types.2';
import { getSizeInfo, getUserAccountProductMeasurementList } from '../graphql/size-info.2';
import { GetSizeInfoVariables } from '../graphql/size-info_types.2';
import {
  PDP_SIZE_INPUT_PAGE_QUERY_KEY,
  USER_ACCOUNT_PRODUCT_MEASUREMENT_LIST_QUERY_KEY,
} from '../services/useSizeInfoMutation';

type Param = GetSizeInfoVariables;

export const QUERY_KEY = ['getSizeInfo'];

export const prefetchSizeInfo = (params: Param, options: GqlRequestOptions, query_client: QueryClient) => {
  const query_options = getSizeInfoQueryOption(params, options);

  return query_client.prefetchQuery(query_options);
};

export const prefetchPdpSizeInputPage = (
  variables: GetPdpSizeInputPageVariables,
  options: GqlRequestOptions,
  query_client: QueryClient,
) => {
  return query_client.prefetchQuery([PDP_SIZE_INPUT_PAGE_QUERY_KEY, variables], async () => {
    return await getPdpSizeInputPage(variables, options);
  });
};

export const prefetchUserAccountProductMeasurementList = (options: GqlRequestOptions, query_client: QueryClient) => {
  return query_client.prefetchQuery([USER_ACCOUNT_PRODUCT_MEASUREMENT_LIST_QUERY_KEY], async () => {
    return await getUserAccountProductMeasurementList(null, options);
  });
};

function getSizeInfoQueryOption(params: Param, options?: GqlRequestOptions) {
  return {
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const { data } = await getSizeInfo(params, { ...options, show_alert: false });

      return {
        item_list: data.pdp_size_info?.item_list ?? [],
        trait_list: data.pdp_base_info?.catalog_product?.trait_list ?? [],
        managed_category_list: data.pdp_base_info?.catalog_product?.managed_category_list ?? [],
      };
    },
    ...queryOptions,
  };
}

export const useSizeInfo = (param: Param, options?: GqlRequestOptions, queryOptions?: { enabled?: boolean }) => {
  const { queryKey, queryFn, ...otherOptions } = getSizeInfoQueryOption(param, options);

  return useQuery(queryKey, queryFn, {
    ...otherOptions,
    ...queryOptions,
  });
};
